// Some tickets have a generic subject ("تاریخ پایان بیمه نامه شرکت") while the real
// company name lives in ticket_subject. This helper merges them into one readable title.
export const BASE_SUBJECT = "تاریخ پایان بیمه نامه شرکت";

export function ticketDisplaySubject(ticket: {
  subject?: string;
  ticket_subject?: string;
}): string {
  const subject = (ticket.subject || "").trim();
  if (subject === BASE_SUBJECT) {
    const ticketSubject = (ticket.ticket_subject || "").trim();
    if (ticketSubject) {
      // strip a leading "شرکت" so it reads "...شرکت X" instead of "...شرکت شرکت X"
      const rest = ticketSubject.replace(/^شرکت\s*/, "");
      return `${BASE_SUBJECT} ${rest}`.trim();
    }
  }
  return ticket.subject || "—";
}
